import { useMutation } from '@apollo/client';
import React, { useState } from 'react';
import { useSetRecoilState } from 'recoil';
import Button from '~/components/Button';
import Input from '~/components/Input';
import Text from '~/components/Text';
import { Identifiers, PATH } from '~/constants/enum';
import { CREATE_ACCOUNT_FROM_ORDER } from '~/data/cart';
import useCmsBlocks from '~/hooks/useCmsBlocks';
import { UserAtom } from '~/services/user';
import styles from './BecomeMember.module.scss';

type Props = {
    order_number: string;
    email?: string;
};

const BecomeMember = ({ order_number, email }: Props) => {
    const setCurrentUser = useSetRecoilState(UserAtom.currentUser);
    const [createAccount, { loading, data }] = useMutation(CREATE_ACCOUNT_FROM_ORDER);
    const { cmsBlocks } = useCmsBlocks([Identifiers.MemberBenefit]);
    const [password, setPassword] = useState('');

    const handleCreateAccount = () => {
        createAccount({
            variables: {
                orderId: order_number,
                password
            }
        });
    };
    const handleGotoDetail = () => {
        // setCurrentUser((prev: any) => ({
        //     ...prev,
        //     email: email,
        //     token: data?.createAccountFromOrder?.token
        // }));
        localStorage.setItem('token', data?.createAccountFromOrder?.token);
        window.location.href = PATH.OrderDetail.replace('[slug]', order_number);
    };

    return (
        <div className="flex flex-col gap-4 rounded-lg">
            {!data?.createAccountFromOrder?.success ? (
                <React.Fragment>
                    <Text type="title-1" className="text-primary">
                        Active your Membership Today!
                    </Text>
                    <Text type="body-1">
                        {' '}
                        Enter your Password to activate your account. Your Account membership gives you update tracking
                        status faster
                    </Text>
                    <Input
                        error={
                            data?.createAccountFromOrder?.message ? (
                                <span>
                                    {data?.createAccountFromOrder?.message}. Go to
                                    <a className="mx-1 hover:underline !text-blue-500" href={PATH.SignUp}>
                                        Sign In
                                    </a>
                                    right now
                                </span>
                            ) : undefined
                        }
                        onChange={(e) => setPassword(e.target.value)}
                        value={password}
                        type="password"
                    ></Input>
                    <Button
                        className="max-w-[200px] ml-auto mx-auto"
                        onClick={handleCreateAccount}
                        disabled={!password}
                        loading={loading}
                    >
                        Create account
                    </Button>
                </React.Fragment>
            ) : (
                <div className="text-center">
                    <p className="text-green-800 text-center"> {data?.createAccountFromOrder?.message} </p>
                    <a
                        href={(PATH.OrderDetail as string).replace('[slug]', order_number)}
                        onClick={handleGotoDetail}
                        className="text-blue-500 text-center"
                    >
                        Go to Order Detail
                    </a>
                </div>
            )}
            {/*  */}
            <div
                className={styles.benefit}
                dangerouslySetInnerHTML={{ __html: cmsBlocks?.[Identifiers.MemberBenefit]?.content }}
            ></div>
        </div>
    );
};

export default BecomeMember;
